function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoCosmosDark(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "uc-social"
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "logo-cosmos-dark_svg__a",
    x1: ".318%",
    x2: "99.969%",
    y1: "49.244%",
    y2: "49.244%"
  }, React.createElement("stop", {
    offset: "2.934%",
    stopColor: "#06AEFF"
  }), React.createElement("stop", {
    offset: "50.43%",
    stopColor: "#0073FF"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#BB80FF"
  })), React.createElement("linearGradient", {
    id: "logo-cosmos-dark_svg__b",
    x1: ".053%",
    x2: "99.989%",
    y1: "50.126%",
    y2: "50.126%"
  }, React.createElement("stop", {
    offset: "0%",
    stopColor: "#0695FF"
  }), React.createElement("stop", {
    offset: "50.43%",
    stopColor: "#0073FF"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#BB80FF"
  })), React.createElement("linearGradient", {
    id: "logo-cosmos-dark_svg__c",
    x1: ".166%",
    x2: "100.101%",
    y1: "50.358%",
    y2: "50.358%"
  }, React.createElement("stop", {
    offset: "2.934%",
    stopColor: "#06AEFF"
  }), React.createElement("stop", {
    offset: "50.43%",
    stopColor: "#0073FF"
  }), React.createElement("stop", {
    offset: "100%",
    stopColor: "#BB80FF"
  }))), React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, React.createElement("g", {
    transform: "translate(0 8)"
  }, React.createElement("path", {
    fill: "url(#logo-cosmos-dark_svg__a)",
    d: "M7.67 1.187c0 .66-.55 1.21-1.208 1.21H6.44c-.242 0-.462-.089-.66-.22-.044-.022-.066-.066-.11-.088a2.462 2.462 0 00-1.428-.462c-.44 0-.857.132-1.231.33-.022 0-.022.022-.044.022a.93.93 0 01-.44.11.901.901 0 01-.68-.308.938.938 0 01-.22-.594c0-.307.153-.57.373-.725a.894.894 0 01.527-.176c.154 0 .308.044.418.11.022.022.044.022.066.044.352.198.77.33 1.209.33.527 0 1.01-.176 1.406-.462.044-.022.088-.066.132-.11a1.09 1.09 0 01.44-.175C6.264 0 6.352 0 6.44 0a1.179 1.179 0 011.23 1.186z"
  }), React.createElement("circle", {
    cx: 0.967,
    cy: 4.264,
    r: 1,
    fill: "#00C4FF"
  }), React.createElement("path", {
    fill: "url(#logo-cosmos-dark_svg__b)",
    d: "M9.868 4.33c0 .726-.571 1.297-1.297 1.297h-.044a1.27 1.27 0 01-.703-.22c-.044-.022-.066-.066-.11-.088a2.683 2.683 0 00-1.538-.505c-.484 0-.923.132-1.319.352-.022 0-.022.022-.044.022a.98.98 0 01-1.187-.22.958.958 0 01-.241-.638c0-.33.153-.615.395-.79a.994.994 0 01.572-.199c.175 0 .33.044.461.11.022.022.044.022.066.044a2.603 2.603 0 002.813-.132c.044-.044.088-.066.132-.11.132-.087.308-.153.462-.197.088-.022.176-.022.263-.022.748 0 1.32.593 1.32 1.296z"
  }), React.createElement("path", {
    fill: "url(#logo-cosmos-dark_svg__c)",
    d: "M7.89 7.473c0 .726-.571 1.297-1.297 1.297H6.55a1.27 1.27 0 01-.703-.22c-.044-.022-.066-.066-.11-.088a2.683 2.683 0 00-1.538-.505c-.484 0-.923.132-1.319.351-.022 0-.022.022-.044.022a.98.98 0 01-1.187-.22.958.958 0 01-.241-.637c0-.33.153-.615.395-.79a.994.994 0 01.572-.199c.175 0 .33.044.461.11.022.022.044.022.066.044a2.603 2.603 0 002.813-.132c.044-.044.088-.066.132-.11.132-.088.308-.154.462-.197.088-.022.176-.022.263-.022.748.022 1.32.593 1.32 1.296z"
  })), React.createElement("path", {
    fill: dark,
    d: "M16.198 15.1a.148.148 0 01-.132-.088l-.088-.22c0-.022-.044-.044-.066-.044-1.099.132-2.132.22-3.099.242h-.022a.469.469 0 01-.264-.066.519.519 0 01-.197-.176.414.414 0 01-.044-.176c0-.132.044-.264.154-.373.44-.528.857-1.1 1.23-1.67.022-.023.022-.045 0-.067-.022-.022-.044-.044-.066-.044h-1.34a.168.168 0 01-.11-.044c-.044-.044-.044-.088-.044-.132l.044-.395c0-.066.066-.132.154-.132h4.835c.044 0 .088.022.11.044a.312.312 0 01.044.132l-.044.395c0 .066-.066.132-.154.132h-2.484c-.022 0-.044.022-.066.022-.351.572-.747 1.121-1.186 1.693-.022.022-.022.044 0 .066.022.043.044.043.066.043.241 0 .571-.021.967-.065.351-.022.769-.066 1.186-.11a.047.047 0 00.044-.044c.022-.022.022-.044 0-.066l-.351-.88a.135.135 0 01.022-.153c.022-.044.066-.066.132-.066h.417c.066 0 .11.044.132.088l.835 1.912a.135.135 0 01-.022.154c-.022.044-.066.066-.132.066h-.461v.022zM12.9 10.66a.168.168 0 01-.11-.044.168.168 0 01-.044-.11l.044-.373c0-.088.066-.132.154-.132h3.78c.044 0 .088.022.11.044a.168.168 0 01.044.11l-.044.373c0 .088-.066.132-.154.132h-3.78zm10.506 4.637c-.044 0-.066-.022-.088-.044a7.527 7.527 0 01-1.187-1.34c0-.022-.022-.022-.044-.022s-.022 0-.044.022c-.44.44-.967.879-1.604 1.319-.022.021-.044.021-.088.021-.022 0-.044 0-.066-.021l-.418-.264a.12.12 0 01-.066-.11.12.12 0 01.066-.11c.725-.506 1.319-.989 1.78-1.495.022-.022.022-.043 0-.065-.395-.704-.681-1.517-.879-2.418 0-.022-.044-.066-.066-.066a.168.168 0 01-.11-.044.168.168 0 01-.044-.11l.044-.44c0-.043.044-.087.11-.087h2.726c.22 0 .373.066.44.22a.65.65 0 01.043.22c0 .087-.022.197-.044.329-.132.461-.33.923-.527 1.34a7.45 7.45 0 01-.748 1.165c-.022.022-.022.044 0 .066a6.976 6.976 0 001.363 1.429c.044.022.044.066.044.11a.12.12 0 01-.066.11l-.461.263c-.022.022-.044.022-.066.022zm-1.847-4.571c-.022 0-.022 0-.044.022 0 .022-.021.022 0 .044a7.52 7.52 0 00.638 1.802c0 .022.022.022.044.022s.022 0 .044-.022c.461-.615.747-1.209.857-1.78v-.044-.044H21.56zm-2.989 4.44a.12.12 0 01-.11-.066.14.14 0 010-.132c.286-.66.572-1.34.814-2.066.022-.066.066-.088.132-.088h.461a.12.12 0 01.11.066.279.279 0 01.022.132c-.11.33-.242.703-.374 1.077-.131.373-.285.703-.395 1.01a.148.148 0 01-.132.089h-.528v-.022zm1.32-2.792c-.023 0-.045 0-.067-.022l-1.12-.527c-.045-.022-.089-.088-.067-.132l.066-.44c0-.065.066-.11.132-.11.022 0 .044 0 .066.023l1.099.527c.044.022.088.088.066.132l-.044.44c-.022.065-.066.11-.132.11zm.285-1.274c-.022 0-.044 0-.066-.022l-1.077-.55c-.044-.022-.088-.088-.066-.132l.044-.44c0-.065.066-.11.132-.11.022 0 .044 0 .066.023l1.077.527c.044.022.088.088.066.132l-.066.462c.022.066-.022.11-.11.11z"
  })));
}

SvgLogoCosmosDark.clsName = 'icon-uc-social__logo-cosmos-dark';
SvgLogoCosmosDark.remarkName = 'unknown';
export default SvgLogoCosmosDark;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoCosmosDark.js
// module id = 2232
// module chunks = 17 18